<script>
  import { createEventDispatcher } from "svelte";
  import { currentLanguage } from "../../store";
  import translations from "../../translations";

  const dispatch = createEventDispatcher();

  export let quantity;
  export let label = null;

  let currentLang = navigator.language.split("-")[0] || "en";

  currentLanguage.subscribe((value) => {
    currentLang = value;
  });

  $: attendeesLabel = typeof label === "string" && label.trim()
    ? label.trim()
    : translations.numberOfAttendees[currentLang] || translations.numberOfAttendees.en;
</script>

<div class="chatwith-booking-quantity-summary">
  <span>{attendeesLabel}: <strong>{quantity}</strong></span>
  <button type="button" on:click={() => dispatch("change")}>
    {translations.change[currentLang] || translations.change.en}
  </button>
</div>
